import thumb_vue_vue_type_script_setup_true_lang_default from "./thumb.vue_vue_type_script_setup_true_lang.mjs";

//#region ../../packages/components/scrollbar/src/thumb.vue
var thumb_default = thumb_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { thumb_default as default };
//# sourceMappingURL=thumb2.mjs.map